import {
  roller,
  aileYetkileri,
  cinsiyetler,
  birimler,
  varsayilanAlisverisKategorileri,
  gelirKategorileri,
  giderKategorileri,
  takvimKategorileri,
} from "./constants";

const LIST_BY_KEY = {
  "const.roles": roller,
  "const.familyAuthorities": aileYetkileri,
  "const.genders": cinsiyetler,
  "const.units": birimler,
  "const.shoppingCategories": varsayilanAlisverisKategorileri,
  "const.incomeCategories": gelirKategorileri,
  "const.expenseCategories": giderKategorileri,
  "const.calendarCategories": takvimKategorileri,
};

export function listOptions(tList, key, fallbackList = []) {
  const values = LIST_BY_KEY[key] || fallbackList;
  const labels = typeof tList === "function" ? tList(key) : [];
  return values.map((value, index) => ({ value, label: labels[index] || value }));
}

const CUSTOM_LABELS_BY_KEY = {
  "const.expenseCategories": {
    "Ev": { tr: "Ev", en: "Home" },
  },
};

function getListLang(labels = []) {
  return labels.includes("Grocery") || labels.includes("Bills") ? "en" : "tr";
}

export function listLabel(tList, key, value) {
  const options = listOptions(tList, key);
  const match = options.find((item) => item.value === value);
  if (match?.label) return match.label;

  const custom = CUSTOM_LABELS_BY_KEY[key]?.[value];
  if (custom) {
    const labels = typeof tList === "function" ? tList(key) : [];
    return custom[getListLang(labels)] || value;
  }

  return value;
}

export function translateKnownListValue(tList, value) {
  if (value === null || value === undefined || value === "") return value;

  for (const key of Object.keys(LIST_BY_KEY)) {
    const options = listOptions(tList, key);
    const match = options.find((item) => item.value === value);
    if (match) return match.label || value;

    const custom = CUSTOM_LABELS_BY_KEY[key]?.[value];
    if (custom) {
      const labels = typeof tList === "function" ? tList(key) : [];
      return custom[getListLang(labels)] || value;
    }
  }

  return value;
}
